import type { App } from 'vue';
import type Express from 'express';

export const setStatusCodePlugin = function (
  app: App<Element>,
  res?: Express.Response,
) {
  const ssrResponseSymbol = 'ssrResponse';
  app.provide(
    ssrResponseSymbol,
    (value: number) => {
      if (res) {
        res.status(value);
      }
    },
  );
};
